import React, {useState} from 'react'
import { Trans, useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {Typography, List, Tooltip} from 'antd'
import {CopyOutlined} from '@ant-design/icons'
import {TwoFAModalStoreInterface} from '@/stores/profile/TwoFAModalStore/TwoFAModalStoreInterface'
import {TwoFAModalStoreSymbol} from '@/pages/Profile/components/TwoFA/components/TwoFAModal'

import styles from './styles.scss'
import {TWO_FA_COPY} from '@/constants/playwright-ids'

export const TwoFARecoveryCode: React.FC<{}> = observer(() => {
    const { t } = useTranslation()
    const {recoveryCodes, setIsModalCloseble} =
        useInjection<TwoFAModalStoreInterface>(TwoFAModalStoreSymbol)
    const [isCopied, setIsCopied] = useState<boolean>(false)

    const recoveryCodesToCopy = recoveryCodes.map(({code}) => `${code}`).join('\r\n')

    const onCopyClick = () => {
        setIsCopied(true)
        navigator.clipboard.writeText(recoveryCodesToCopy)
        setIsModalCloseble(true)
        setTimeout(() => setIsCopied(false), 300)
    }

    return (
        <div>
            <Typography.Text>
                <Trans i18nKey='TwoFARecoveryCode.title' components={{ br: <br/> }} />
            </Typography.Text>

            <div className={styles.listHolder}>
                <List
                    className={styles.codes}
                    size={'small'}
                    bordered
                    dataSource={recoveryCodes}
                    renderItem={({code}) => <List.Item>{code}</List.Item>}
                />

                <div className={styles.buttonHolder}>
                    <Tooltip title={t('TwoFARecoveryCode.copied')} placement={'top'} open={isCopied}>
                        <CopyOutlined className={styles.icon} onClick={onCopyClick} data-test-id={TWO_FA_COPY} />
                    </Tooltip>
                </div>
            </div>

            <div className={styles.footer}>
                <Typography.Text>{t('TwoFARecoveryCode.copyText')}</Typography.Text>

                <ul>
                    <li>{t('TwoFARecoveryCode.warning.line1')}</li>
                    <li>{t('TwoFARecoveryCode.warning.line2')}</li>
                    <li>{t('TwoFARecoveryCode.warning.line3')}</li>
                </ul>
            </div>
        </div>
    )
})
